// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/laravel-mix/node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/laravel-mix/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".img-enviando[data-v-56612e75]{width:250px}", "",{"version":3,"sources":["webpack://./resources/assets/js/app/Emails/Coletivo/EmailColetivo.vue"],"names":[],"mappings":"AACA,+BACI,WAAJ","sourcesContent":["\n.img-enviando{\n    width: 250px;\n    // height:\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
